import { Badge, ProgressBar } from 'react-bootstrap';
import moment from 'moment';
import { FaSyncAlt } from 'react-icons/fa';

const OperatorSyncCard = ({
  title,
  operatorKey,
  courseProgress,
  onInlineSync,
}) => {
  const records = courseProgress.filter((cp) => cp.operator === operatorKey);
  const hasRecords = records.length > 0;

  return (
    <div className='col-md-12 oper-cards'>
      <div className='row'>
        <div className='col-md-6'>
          <h3>{title}</h3>
        </div>
        <div className='col-md-6 text-right'>
          {onInlineSync && (
            <button
              className='btn btn-sm btn-light mr-5'
              onClick={onInlineSync}
            >
              {/* <FaSyncAlt /> */}
            </button>
          )}
          {records.map((cp, index) =>
            cp.status == 'Inprogress' || cp.status == 'Started' ? (
              <Badge key={index} bg='warning' text='dark'>
                In Progress ({cp.progress.toFixed(2)}%)
              </Badge>
            ) : cp.status == 'Completed' ? (
              <Badge key={index} bg='success' text='light'>
                Completed
              </Badge>
            ) : (
              cp.status == 'Error' && (
                <Badge key={index} bg='danger' text='light'>
                  Error
                </Badge>
              )
            )
          )}
        </div>
      </div>

      <div className='row '>
        <div className='col-md-12'>
          {hasRecords ? (
            records.map((cp, index) => (
              <ProgressBar
                key={index}
                striped={cp.progress === 100 ? false : true}
                min={0}
                animated={cp.progress === 100 ? false : true}
                now={cp.progress}
                label={`${cp.progress.toFixed(2)}%`}
                variant={cp.progress === 100 ? 'success' : 'primary'}
              />
            ))
          ) : (
            <ProgressBar striped min={0} animated now={0} label={`0%`} />
          )}
        </div>
      </div>

      <div className='row mt-10'>
        <div className='col'>
          <b>Start Time</b>
          {hasRecords ? (
            records.map((cp, index) => (
              <p key={index}>
                {moment(cp.startTime).format('DD-MM-yyyy hh:mm a')}
              </p>
            ))
          ) : (
            <p>N/A</p>
          )}
        </div>
        <div className='col'>
          <b>End Time</b>
          {hasRecords ? (
            records.map((cp, index) => (
              <p key={index}>
                {cp.endTime != null
                  ? moment(cp.endTime).format('DD-MM-yyyy hh:mm')
                  : 'N/A'}
              </p>
            ))
          ) : (
            <p>N/A</p>
          )}
        </div>
        <div className='col-md-4'>
          <b>Duration</b>
          {hasRecords ? (
            records.map((cp, index) => <p key={index}>{cp.duration}</p>)
          ) : (
            <p>0</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default OperatorSyncCard;
